export function enabled() {
  return process.env.NODE_ENV !== 'production';
}

export function trackWarn(eventName, args) {
  if (enabled()) {
    console.warn(`${eventName}`, args);
  }
}
